import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { LocalStorageKeys } from '../shared/models/user';

@Injectable({ providedIn: 'root' })
export class SharedService {
  userDetail = new BehaviorSubject(null);
  constructor() {
  }
  setLoading$ = new Subject<any>();
  setLoader(set: boolean) {
    this.setLoading$.next(set);
  }

  
  private isConnectedSource = new BehaviorSubject<string>(window.localStorage.getItem(LocalStorageKeys.Is_connected) || 'false');
  isConnected$ = this.isConnectedSource.asObservable();
  
  updateLnkdConnected(value: string) {
    this.isConnectedSource.next(value);
    window.localStorage.setItem(LocalStorageKeys.Is_connected, value);
  }
  // for facebook consumer
  private isFbConnectedSource = new BehaviorSubject<string>(window.localStorage.getItem(LocalStorageKeys.Is_fb_connected) || 'false');
  isFbConnected$ = this.isFbConnectedSource.asObservable();

  updateFbConnected(value: string) {
    this.isFbConnectedSource.next(value);
    window.localStorage.setItem(LocalStorageKeys.Is_fb_connected, value);
  }

  // for facebook business
  private isFbBusinessConnectedSource = new BehaviorSubject<string>(window.localStorage.getItem(LocalStorageKeys.Is_fb_business_connected) || 'false');
  isFbBusinessConnected$ = this.isFbBusinessConnectedSource.asObservable();

  updateFbBusinessConnected(value: string) {
    this.isFbBusinessConnectedSource.next(value);
    window.localStorage.setItem(LocalStorageKeys.Is_fb_business_connected, value);
  }  

  // for instagram
  private isInstaConnectedSource = new BehaviorSubject<string>(window.localStorage.getItem(LocalStorageKeys.Is_insta_connected) || 'false');
  isInstaConnected$ = this.isInstaConnectedSource.asObservable();

  updateInstaConnected(value: string) {
    this.isInstaConnectedSource.next(value);
    window.localStorage.setItem(LocalStorageKeys.Is_insta_connected, value);
  }  

  // for twitter
  private isTwitterConnectedSource = new BehaviorSubject<string>(window.localStorage.getItem(LocalStorageKeys.Is_twitter_connected) || 'false');
  isTwitterConnected$ = this.isTwitterConnectedSource.asObservable();

  updateTwitterConnected(value: string) {
    this.isTwitterConnectedSource.next(value);
    window.localStorage.setItem(LocalStorageKeys.Is_twitter_connected, value);
  } 



  private isConnectedLinkedInUserSource = new BehaviorSubject<string>(window.localStorage.getItem(LocalStorageKeys.LinkedInUserName) || '');
  isConnectedUserName$ = this.isConnectedLinkedInUserSource.asObservable();
  
  updateLnkdConnectedUserName(value: string) {
    this.isConnectedLinkedInUserSource.next(value);
    window.localStorage.setItem(LocalStorageKeys.LinkedInUserName, value);
  }

  private isConnectedFacebookUserSource = new BehaviorSubject<string>(window.localStorage.getItem(LocalStorageKeys.FacebookInUserName) || '');
  isConnectedFacebookUserName$ = this.isConnectedFacebookUserSource.asObservable();

  updateFacebookConnectedUserName(value: string) {
    this.isConnectedFacebookUserSource.next(value);
    window.localStorage.setItem(LocalStorageKeys.FacebookInUserName, value);
  }

  private isConnectedFacebookBusinessUserSource = new BehaviorSubject<string>(window.localStorage.getItem(LocalStorageKeys.FacebookBusinessUserName) || '');
  isConnectedFacebookBusinessUserName$ = this.isConnectedFacebookBusinessUserSource.asObservable();

  updateFacebookBusinessConnectedUserName(value: string) {
    this.isConnectedFacebookBusinessUserSource.next(value);
    window.localStorage.setItem(LocalStorageKeys.FacebookBusinessUserName, value);
  } 

  // for instagram
  private isConnectedInstaUserSource = new BehaviorSubject<string>(window.localStorage.getItem(LocalStorageKeys.InstaUserName) || '');
  isConnectedInstaUserName$ = this.isConnectedInstaUserSource.asObservable();

  updateInstaConnectedUserName(value: string) {
    this.isConnectedInstaUserSource.next(value);
    window.localStorage.setItem(LocalStorageKeys.InstaUserName, value);
  } 

  // for twitter
  private isConnectedTwitterUserSource = new BehaviorSubject<string>(window.localStorage.getItem(LocalStorageKeys.TwitterUserName) || '');
  isConnectedTwitterUserName$ = this.isConnectedTwitterUserSource.asObservable();

  updateTwitterConnectedUserName(value: string) {
    this.isConnectedTwitterUserSource.next(value);
    window.localStorage.setItem(LocalStorageKeys.TwitterUserName, value);
  } 

  private _sidebarVisible = new BehaviorSubject<boolean>(false);
  private _sidebarData = new BehaviorSubject<any>(null);

  // Observable for sidebar visibility
  sidebarVisible$ = this._sidebarVisible.asObservable();

  // Observable for sidebar data
  sidebarData$ = this._sidebarData.asObservable();

  // Method to toggle visibility
  toggleSidebar(visible: boolean, data: any = null): void {
    this._sidebarVisible.next(visible);
    if (data) {
      this._sidebarData.next(data);
    }
  }
}
